import { BillingPortalSessionResponseSchema, CreateBillingPortalSessionRequestSchema, TenantBillingSummaryResponseSchema, } from '../../schemas.js';
/** REST contract for `insight-api/src/routes/tenant/billing-*.routes.ts`. */
export const tenantBillingContract = {
    getSummary: {
        method: 'GET',
        path: '/tenant/billing/summary',
        response: TenantBillingSummaryResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get billing summary',
    },
    createPortalSession: {
        method: 'POST',
        path: '/tenant/billing/portal/session',
        body: CreateBillingPortalSessionRequestSchema,
        response: BillingPortalSessionResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to create billing portal session',
    },
};
//# sourceMappingURL=tenant-billing.contract.js.map